import { z } from 'zod';
/** Capability exposed by Platform for tenant-bound CRM2 membership resolution. */
export const platformImportResolutionCapability = 'platform.import-resolution.v1';
export const platformImportResolutionEntityType = 'membership';
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
/** The only entity currently supported by the Platform import-resolution boundary. */
export const platformImportResolutionEntityTypeSchema = z.literal(platformImportResolutionEntityType);
/** Exact proof returned by platform.verify_import_resolution_v1. */
export const platformImportResolutionSchema = z.strictObject({
    capability: z.literal(platformImportResolutionCapability),
    entityType: platformImportResolutionEntityTypeSchema,
    sourceTenantExternalKey: z.string().trim().min(1).max(120),
    sourceId: z.string().trim().min(1).max(240),
    targetId: z.string().uuid(),
    sourceSha256: sha256Schema,
    sourceUpdatedAt: z.string().datetime({ offset: true }),
    runId: z.string().uuid(),
    targetSha256: sha256Schema,
});
/** Descriptive alias for callers that want to name the value as a proof. */
export const platformImportResolutionProofSchema = platformImportResolutionSchema;
//# sourceMappingURL=platform-import-resolution.contract.js.map